// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useEffect} from 'react';
import {oculus_img_url} from '../../../../hola/pub/ui/oculus_img_url';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {use_screen} from '../../../../hola/pub/lib/screen_util';
import {t_page_meta} from '../../../../toolip/pub/types';
import Icon_arrow_right from '../../img/icons/24/arrow_right.svg';
import {Button} from '../../../pub/lib/button';
import {perr_www_visit} from 'hola_pub_util';
import styles from './404.module.less';
import cn from 'classnames';

export const Root = ()=>{
    const {theme} = useContext(Settings_context);
    useEffect(()=>{
        perr_www_visit({id: 'oculus_404_visit'});
    }, []);
    const {width} = use_screen();
    return <div className={styles.not_found_page}>
      <img src={oculus_img_url(`404.svg`)}/>
      {width > 768 ? <h2>Oops! Page not found.</h2> :
        <h3>Oops! Page not found.</h3>}
      <p className={cn(theme.p16, theme.med)}>The page you were trying to
        reach doesn't exist anymore, or maybe it has just moved. Feel free
        to <a href='mailto:support@oculusproxies.com'
          className={styles.support}> contact</a> us if the problem persists
          or if you can't find what you are looking for.</p>
      <Button
        caption={<>Go to homepage <Icon_arrow_right/></>} to={'/'}
        size={'l'}/>
    </div>;
};

const meta: t_page_meta = {
    meta: {
        title: 'Page not found | Oculus',
        description: 'Page not found | 404 Error',
        canonical_url: 'https://oculusproxies.com',
        robots: 'noindex',
    },
    ssr_force: true,
    no_ssr: false,
};

Root.meta = meta;
